import request from "@/utils/request";

export async function cityQuery(pageNum, pageSize, cityName) {
    return new Promise((resolve) => {
        // 模拟API调用，实际应用中应该用uni.request等API进行网络请求
        setTimeout(async () => {
            await request.post('/area/list', {
                pageNum: pageNum,
                pageSize: pageSize,
                areaName: cityName
            })
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log("cityQuery error:" + error);
                });
        }, 1000);
    });
}
